import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { getEstabelecimentoAtualId } from '../lib/estabelecimento';

export interface Branding {
  /** Nome de exibição da prefeitura. */
  nome: string;
  /** Slogan/subtítulo opcional. Vazio se não definido. */
  slogan: string;
  /** URL do brasão; cai no ícone padrão se não houver. */
  logoUrl: string;
}

const PADRAO: Branding = { nome: 'Comunicação', slogan: '', logoUrl: '/icone-pwa.svg' };

/**
 * Marca da prefeitura para white-label. Lê a linha de `estabelecimentos`
 * (leitura anon liberada pela policy de branding) — funciona antes do login.
 */
export function useBranding(): Branding {
  const [branding, setBranding] = useState<Branding>(PADRAO);

  useEffect(() => {
    let vivo = true;
    supabase
      .from('estabelecimentos')
      .select('nome, nome_fantasia, logo_url, configuracoes')
      .eq('id', getEstabelecimentoAtualId())
      .maybeSingle()
      .then(({ data }) => {
        if (!vivo || !data) return;
        const cfg = data.configuracoes as { slogan?: string } | undefined;
        const nome = data.nome_fantasia || data.nome || 'Comunicação';
        setBranding({ nome, slogan: cfg?.slogan ?? '', logoUrl: data.logo_url || '/icone-pwa.svg' });
        document.title = nome;
      });
    return () => { vivo = false; };
  }, []);

  return branding;
}
